export default (params) => ({
  trigger: {
    name: 'service_accessory_overlays.view_recommendations',
    params: params,
  },
  config: {
    schema: {
      item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
      sub_feature: {
        enum: [
          'wall_mount_selector_recommendations',
          'stacking_kit_overlay_recommendations',
        ],
      },
    },
    event: {
      name: 'view_items',
      params: {
        has_highlighted_segment: null,
      },
    },
    nonInt: true,
  },
});
